import axios from "axios";

const api = axios.create({
  baseURL: "https://api.farmfox.co/farmfox",
  timeout: 10000
});

export default api;